<div class="forgot-password-modal text-center">
  <div class="dialog-header">
    <h3 class="dialog-title">{{ 'FORGOT_PASSWORD.FORGOT_PASSWORD' | transloco }}</h3>
    <p class="dialog-subtitle">{{ 'FORGOT_PASSWORD.ENTER_EMAIL' | transloco }}</p>
  </div>

  <form [formGroup]="newPasswordForm" (ngSubmit)="forgotPassword()" class="dialog-form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" type="email" formControlName="email">
      <mat-icon matSuffix class="email-icon">email</mat-icon>
      @if (newPasswordForm.get('email')?.errors?.required) {
      <mat-error>
        {{ 'FORGOT_PASSWORD.MUST_ENTER_EMAIL' | transloco }}
      </mat-error>
      }

      @if (newPasswordForm.get('email')?.errors?.email) {
      <mat-error>
        {{ 'FORGOT_PASSWORD.INVALID_EMAIL' | transloco }}
      </mat-error>
      }
    </mat-form-field>

    <div class="dialog-actions">
      <button mat-raised-button color="primary" class="submit-btn" type="submit" [disabled]="!newPasswordForm.valid">
        {{ 'FORGOT_PASSWORD.SEND_NEW_PASSWORD' | transloco }}
      </button>
    </div>
  </form>
</div>